import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    borderBottom: [1, 'solid', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
    },
  },
  homePriceBox: {
    width: '100%',
    borderBottom: [1, 'solid', theme.palette.colors.border],
    padding: [theme.spacing(3), theme.spacing(4)],
    [theme.breakpoints.up('mobile')]: {
      width: '35%',
      borderBottom: 'none',
      borderRight: [1, 'solid', theme.palette.colors.border],
    },
  },
  highlight: {
    fontWeight: 800,
    marginRight: theme.spacing(1),
  },
  rightBox: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: '65%',
    },
  },
  rightTopBar: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      borderBottom: [1, 'solid', theme.palette.colors.border],
    },
  },
  downPaymentBox: {
    width: '50%',
    padding: [theme.spacing(3), theme.spacing(1), theme.spacing(3), theme.spacing(4)],
    [theme.breakpoints.up('mobile')]: {
      borderRight: [1, 'solid', theme.palette.colors.border],
      padding: [theme.spacing(3), theme.spacing(4)],
    },
  },
  mortgageLoanBox: {
    width: '50%',
    padding: [theme.spacing(3), theme.spacing(4), theme.spacing(3), theme.spacing(1)],
    [theme.breakpoints.up('mobile')]: {
      padding: [theme.spacing(3), theme.spacing(4)],
    },
  },
  label: {
    fontWeight: 600,
    padding: [theme.spacing(1), theme.spacing(1), theme.spacing(1), 0],
    overflow: 'hidden',
    position: 'relative',
    display: 'inline-block',
    zIndex: 0,
    '&::before': {
      content: "''",
      position: 'absolute',
      left: '50%',
      bottom: 5,
      width: `calc(100% - ${theme.spacing(1)}px)`,
      height: 10,
      transform: ['skew(-12deg)', 'translateX(-50%)'],
      background: theme.palette.colors.teal,
      zIndex: -1,
      opacity: '50%',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MainSummaryBar/useStyles.js